/**
 * Режимы глобальных настроек переводов между пользователями
 */
export enum TransferPolicyMode {
  /**
   * Полный запрет переводов для всех
   */
  DISABLED = 'disabled',

  /**
   * Разрешено всем без условий
   */
  ALLOWED_FOR_ALL = 'allowed_for_all',

  /**
   * Разрешено только пользователям с флагом isTransferEnabled
   */
  ALLOWED_FOR_USERS = 'allowed_for_users',

  /**
   * Разрешено пользователям с флагом + страна должна быть в списке
   */
  ALLOWED_FOR_USERS_AND_COUNTRIES = 'allowed_for_users_and_countries',

  /**
   * Разрешено только по стране (флаг пользователя игнорируется)
   */
  ALLOWED_FOR_SELECTED_COUNTRIES = 'allowed_for_selected_countries',
}
